<template>
  <div id="vocabularyCardBody">
    <transition name="fade" mode="out-in" appear v-if="currentComponent === 'vocabularyCardWordsRemoval'">
      <vocabulary-card-words-removal :style="!isMobile?'grid-column: 2/3;grid-row: 1/3;':''"
                                     :vocab="vocab"
                                     :vocabLoaded="vocabLoaded"
      >
      </vocabulary-card-words-removal>
    </transition>
    <transition name="fade" mode="out-in" appear v-else>
        <div id="whitebg2"
             :class="{lightGoldTheme:levelword>=3, lightSilverTheme:levelword==2, lightCopperTheme:levelword==1, lightStandardTheme:levelword==0, }">
          <transition name="fade" mode="out-in" appear>
            <vocabulary-card-word v-if="displayWord" id="component" :vocab="vocab" :word-to-display="currentWord"
                                  @nextClicked="set_displayWord(false); set_currentWord(null)">
            </vocabulary-card-word>
            <component v-else id="component" :key="wordNum+testNum" v-bind:is="currentComponent" v-bind="propsTab" :vocab="vocab"
                       @nextClicked="next" >
            </component>

          </transition>

          <transition name="fade" mode="out-in">
            <div :key="componentMessage" id="componenttype" :style="styleObject"
                 class="plainStandardTheme flexwrap centercenter paddingRound">
                      <span><span
                          v-html="componentMessage"></span></span>
            </div>
          </transition>
          <!--
          <div id="progress" class="flexwrap centercenter" v-if="wordNum+testNum<vocab.length * 4" style="flex-direction: column"
               :class="{plainGoldTheme:levelword>=3, plainSilverTheme:levelword==2, plainCopperTheme:levelword==1,
               plainStandardTheme:levelword==0, }">
            <div >{{wordNum+testNum}}</div>
            <div style="border-top-width: 0.1vw; border-top-style: solid; font-size: 0.7em;">{{ vocab.length * 4 }}</div>
          </div>
          -->
        </div>
    </transition>

    <transition name="fadeleave" mode="out-in" appear>
      <div id="progress" v-if="wordNum+testNum<vocab.length * 4 && vocabLoaded && currentComponent!='vocabularyCardWordsRemoval'" :key="wordNum+testNum<vocab.length * 4">
        <!--<i class="fas fa-stopwatch"></i>-->
        <div>
          <progress-bar-step :key="vocabSessionNum" :value="(wordNum+testNum)/(vocab.length * 4)*1000" class="standardTheme"
                             :withoutColor="isMobile"
                             :hue="currentShow.hue"
                             @timerOut="end"
                             v-show="currentComponent === 'vocabularyCardWord' || currentComponent === 'vocabularyCardTest'"
          ></progress-bar-step>
        </div>
      </div>
    </transition>

    <vignette :icon="'fa-graduation-cap'" :color="'#007a9d'" :review="sessionType=='season'" v-if="!isMobile" ></vignette>
    <div id="beingLearnt" v-if="!isMobile">
      <transition-group tag="h3" name="slidefade" v-for="(word, id) in learntWords" :key="id" appear>
        <div class="wordBeingLearnt smallRoundAngles paddingRound slidefade-item clickable"
             @click="set_currentWord(word); set_displayWord(true);" :key="id" :class="{lightGoldTheme:level(word)>=3, lightSilverTheme:level(word)==2,
            lightCopperTheme:level(word)==1, lightStandardTheme:level(word)==0, }">
          {{ word.lemma.decenglish }}
          <div class="flexwrap centercenter " style="overflow: hidden">
            <radial-progress-bar :diameter="20" :strokeWidth="3" :strokeLinecap="'butt'"
                                 :completed-steps="word.lemmaCount"
                                 :total-steps="3" :startColor="'#ffffff'" :stopColor="'#ffffff'"
                                 :innerStrokeColor="'#00000055'"  v-if="word.lemmaCount<3"></radial-progress-bar>
            <span v-else class="vocabPoints">+5pts</span>
          </div>

        </div>
      </transition-group>
    </div>
  </div>

</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import axios from "axios";
import {mapGetters, mapActions} from 'vuex'
import {API_URL} from "@/App";
import {lock} from "../main";

export default {
  name: "vocabularyCard",

  props: {
    vocab: Array,
    vocabLoaded: Boolean
  },

  components: {
    Vignette: () => import(/* webpackPrefetch: true */ '@/components/vignette.vue'),
    ProgressBarStep: () => import(/* webpackPrefetch: true */ '@/components/progressBarStep.vue'),
    LoadingLogo: () => import(/* webpackPrefetch: true */ '@/components/loadingLogo.vue'),
    vocabularyCardWord: () => import(/* webpackPrefetch: true */ '@/components/vocabularyCardWord.vue'),
    vocabularyCardWordsRemoval: () => import(/* webpackPrefetch: true */ '@/components/vocabularyCardWordsRemoval.vue'),
    vocabularyCardTest: () => import(/* webpackPrefetch: true */ '@/components/vocabularyCardTest.vue'),
    vocabularyRecapCard: () => import(/* webpackPrefetch: true */ '@/components/vocabularyRecapCard.vue'),
    vocabularySessionProgressBar: () => import(/* webpackPrefetch: true */ '@/components/vocabularySessionProgressBar.vue'),
    RadialProgressBar
  },

  created() {
    if(!this.$isDebug) {
      fbq('track', 'StartSession');
    }

    //this.$session.set('duration', 1 * 60 * 1000);
    this.set_endSession(false);
    this.set_wordNum(1);
    this.set_testNum(0);
    this.reset_learntWords();
    this.set_vocabSessionNum(1);
    if(this.sessionType != "season"){
      this.set_currentComponent("vocabularyCardWordsRemoval");
    }
    else{
      this.set_currentComponent("vocabularyCardWord");
    }

    this.sessionDuration = this.duration.mainSession * 60 * 1000;

    // Si vocab est chargé direct (session de type saison), on initialise le count des mots à 3
    if(this.vocabLoaded) {
      this.vocab.forEach((element) => {
        element['lemmaCount'] = 3;
        /*if(array.length >= index+1  ) {
          this.set_currentEpisodeData(this.currentEpisodeData)
        }*/
      })
    }

  },

  destroyed() {
    this.set_currentComponent("");
    this.set_sessionWordsListLoaded(false)
    this.reset_lemmasToRemoveIds();
  },

  watch: {
    //On initialise le timer avec sa durée quand le vocabulaire est chargé
    // Le vocabulaire se charge uniquement pour la première session
    'vocabLoaded': function () {
      this.set_currentComponent("vocabularyCardWordsRemoval");
      this.vocab.forEach((element) => {
        element['lemmaCount'] = 3;
        /*if(array.length >= index+1  ) {
          this.set_currentEpisodeData(this.currentEpisodeData)
        }*/
      })

      this.sessionDuration = this.duration.mainSession * 60 * 1000;
      //this.$session.set('duration', this.duration);
    },
    // On ajuste la durée pour une session bonus
    'vocabSessionNum': function () {
      this.sessionDuration = this.duration.bonusSession * 60 * 1000;
      //this.$session.set('duration', this.duration);
    },
  },
  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile',
      'apiData',
      'states',
      'level_copper',
      'level_silver',
      'level_gold'
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
      'currentShow',
      'currentSeason',
      'currentWordsLearnt',
    ]),
    ...mapGetters('session', [
        'sessionType',
      'wordNum',
      'testNum',
      'testNumSerie',
      'currentComponent',
      'currentWord',
      'displayWord',
      'vocabSessionNum',
      'endSession',
      'learntWords',
      'learntLemmasId',
      'lemmasToRemoveIds',
      'startDate',
      'errorsNumber',
      'duration',
      'sessionFinished'
    ]),
    levelword: function () {
      if (this.currentWord != undefined && this.currentWord.lemma.user_lemma.length > 0) {
        return this.currentWord.lemma.user_lemma[0].knowledge_level
      }
      return 0
    },

    componentMessage: function () {
      switch (this.currentComponent) {
        case 'vocabularySessionStart':
          return "Bienvenue !"
        case 'vocabularyCardWord':
          if (this.levelword === 1 || this.levelword === 2) {
            return "Mot déjà vu"
          } else {
            return "Nouveau Mot"
          }
        case 'vocabularyCardTest':
          return "Traduis !"
      }
      return ""
    },

    propsTab: {
      get: function () {
        return this.properties;
      },
      set: function (newValue) {
        this.properties = newValue;
        this.$session.set('propsTab', newValue);
      }
    },

    styleObject: function () {
      let return_value = {'--color': this.currentShow.color};
      if (this.currentComponent === "vocabularyCardWord") {
        return_value["--text_color"] = 'var(--learnColor)'
      }
      if (this.currentComponent === "vocabularyCardTest") {
        return_value["--text_color"] = 'var(--watchColor)'
      }

      return return_value

    }
  },

  methods: {
    ...mapActions('global', [
      'set_appStep',
      'set_carousselNavTo',
      'set_level_copper',
      'set_level_silver',
      'set_level_gold',
      'change_userData',
      'update_userDatas',
      'set_userDatas',
        'set_navOpened',
        'set_dataLoaded',
        'set_dataReload'
    ]),
    ...mapActions('show', [
      'set_currentEpisodeData',
      'change_currentEpisodeData',
        'update_currentWordLearnt'
    ]),
    ...mapActions('session', [
      'set_sessionWordsListLoaded',
      'set_wordNum',
      'set_testNum',
      'set_testNumSerie',
      'set_currentComponent',
      'set_currentWord',
      'set_displayWord',
      'set_vocabSessionNum',
      'set_endSession',
      'reset_learntWords',
      'reset_lemmasToRemoveIds',
      'set_sessionFinished'
    ]),
    populateVoiceList: function () {
      this.properties.voicesListValue = window.speechSynthesis.getVoices();
    },
    level: function (word) {
      let curlevel = 0;
      if (word.lemma.user_lemma.length > 0) {
        curlevel = word.lemma.user_lemma[0].knowledge_level
      }
      if (word.lemmaCount === 3) {
        curlevel += 1
      }
      return curlevel
    },

    next: function () {
      // Si on arrive au bout de la liste, on active endSession
      if (this.wordNum >= this.vocab.length) {
        this.set_endSession(true);
      }

      if (!this.endSession) {
        if (this.wordNum < 3) {
          this.set_wordNum(this.wordNum + 1);
        } else if (this.wordNum === 3) {
          if (this.currentComponent === "vocabularyCardWord") {
            this.set_testNum(this.testNum + 1);
            this.set_currentComponent("vocabularyCardTest");
          } else if (this.currentComponent === "vocabularyCardTest") {
            this.set_wordNum(this.wordNum + 1);
            this.set_currentComponent("vocabularyCardWord");
          }
        }
        // A partir de là on alterne 2 quiz puis 1 mot
        else if (this.wordNum > 3) {
          if (this.currentComponent === "vocabularyCardWord") {
            this.set_testNum(this.testNum + 1);
            this.set_testNumSerie(1);
            this.set_currentComponent("vocabularyCardTest");
          }
          // Après un quiz, on enchaîne sur un autre quiz si c'était le premier quiz de la série, sinon on enchaîne sur un mot
          else if (this.currentComponent === "vocabularyCardTest") {
            if (this.testNumSerie === 1) {
              this.set_testNum(this.testNum + 1);
              this.set_testNumSerie(this.testNumSerie + 1);
              this.set_currentComponent("vocabularyCardTest");
            } else if (this.testNumSerie === 2) {
              this.set_wordNum(this.wordNum + 1);
              this.set_testNumSerie(0);
              this.set_currentComponent("vocabularyCardWord");
            }
          }
        }
      } else if (this.endSession) {
        // S'il n'y a plus de mots parmi ceux déjà vus, on passe au synopsis
        if (!this.stillWord(this.vocab.slice(0, this.wordNum))) {
          // On envoie à level_count le nouveau décompte des mots appris
          this.newLearntWords();
          this.postSession();

          this.profile.datas.points += 50
          // On met à jour dans le store le nombre de mots appris dans l'épisode
          if(this.sessionType === 'episode') {
            this.currentEpisodeData.vocab_sessions.push({'stars': this.learntLemmasId.length})
            this.currentEpisodeData.user_episode.check = 1
            this.currentEpisodeData.user_episode.points += 50
            this.currentEpisodeData.user_episode.learn_check = true
            this.currentEpisodeData.user_episode.learn_number += 10
          }
          if (this.currentEpisodeData.user_episode.play_check && this.currentEpisodeData.user_episode.watch_check &&
              this.currentEpisodeData.user_episode.learn_check && this.currentEpisodeData.user_episode.uq_check) {
            this.currentEpisodeData.user_episode.check = 2
          }
          this.set_sessionFinished(this.sessionFinished + 1)
          this.set_currentWord(null)
          this.returnMenu()
          //this.set_carousselNavTo(1)
          //this.set_appStep(this.states.MENU)
        }
        // Sinon on enchaîne les quizz
        else {
          this.set_testNum(this.testNum + 1);
          this.set_testNumSerie(this.testNumSerie + 1);
          this.set_currentComponent("vocabularyCardTest");
        }
      }

    },
    postSession() {

      if(!this.$isDebug) {
        gtag('event', 'PostSession', {
          'event_category': 'Session'
        })

        fbq('track', 'Session Posted');
      }

      this.change_userData({
        name: 'today_session',
        value: true})

      let date = new Date();
      let device = "PC"
      if (this.screenWidth <= 767) {
        device = "mobile"
      }
      let episodeId = -1;
      if(this.sessionType === 'season') {
        episodeId = this.currentSeason.prep_episode_id;
      }
      else if(this.sessionType === 'episode') {
        episodeId = this.currentEpisodeData.id;
      }
      let payload = {
        "user": this.profile.sub,
        "episode": episodeId,
        "lemmas_learned": this.learntLemmasId,
        "start_session": this.startDate,
        "end_session": date.toISOString(),
        "length": this.duration.mainSession + (this.vocabSessionNum - 1) * this.duration.bonusSession,
        "stars": this.learntLemmasId.length,
        "errors": this.errorsNumber,
        "completed": true,
        "device": device
      }
      let token = "";
      const url = `${API_URL}/api/session/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          token = authResult.accessToken;
          axios.post(url, payload, {headers: {Authorization: `Bearer ${token}`}})
              .then(response => {
                // Données à modifier en front-end :
                // Score global
                // score saison
                // mots or, argent, bronze
                // mots déjà vu de la saison
                // objectif hebdomadaire
                // Accomplissements

                //this.update_userDatas(response.data)
                this.set_dataReload()
              })
        }
        else {
          console.log(error)
        }
      });

      if(this.lemmasToRemoveIds.length>0){
        let token = "";
        const url = `${API_URL}/api/remove_lemmas/`
        this.$webAuth.checkSession({}, (error, authResult) => {
          if(!error) {
            token = authResult.accessToken;
            axios.post(url, this.lemmasToRemoveIds, {headers: {Authorization: `Bearer ${token}`}})
                .then(response => {
                  console.log(response.data)
                })
          }
          else {
            console.log(error)
          }
        });
      }
    },

    returnMenu() {
      this.set_carousselNavTo(1)
      this.set_appStep(this.states.MENU)
      this.set_navOpened(false)
      window.setTimeout( () =>{
      }, 50);
    },

    stillWord(liste) {
      let remainingWords = [];
      if (liste.length >= 1) {
        for (let i = 0; i < liste.length; i++) {
          if (liste[i].lemmaCount >= 1) {
            remainingWords.push(i);
          }
          if (remainingWords.length >= 1) {
            return true;
          }
        }
      }
      return false;
    },

    end: function () {
      this.set_endSession(true);
    },

    intSum: function (nb) {
      let sum = 0;
      for (let i = 0; i <= nb; i++) {
        sum = sum + i;
      }
      return sum;
    },
    get_level: function (num) {
      let i;
      if (this.level_count != undefined && this.level_count != null) {
        this.level_count.forEach((element) => {
          if (element['knowledge_level'] == num) {
            return element['the_count']
          }
        })
      }
      return 0
    },

    newLearntWords: function () {
      // On calcule le nombre de nouveau mots bronze, argent et or de la session accomplie
      // Puis on met à jout current_level
      let newBronze = 0;
      let newSilver = 0;
      let newGold = 0;
      // On parcours learntWords pour compter les nouveaux niveaux
      for (let i = 0; i < this.learntWords.length; i++) {
        let word = JSON.parse(JSON.stringify(this.learntWords[i]))
        // Si le mot était inconnu, il est maintenant bronze
        if (this.learntWords[i].lemma.user_lemma.length <= 0) {
          //Adding words to current season words_learnt
          word.lemma.user_lemma = [{'knowledge_level': 1, 'last_studied': new Date().toISOString()}]
          this.currentWordsLearnt.push(word)
          //Update stars
          newBronze++;
        } else if (this.learntWords[i].lemma.user_lemma[0].knowledge_level === 1) {
          word.lemma.user_lemma = [{'knowledge_level': 2, 'last_studied': new Date().toISOString()}]
          this.update_currentWordLearnt(word)
          newSilver++;
          newBronze--;
        } else if (this.learntWords[i].lemma.user_lemma[0].knowledge_level === 2) {
          word.lemma.user_lemma = [{'knowledge_level': 3, 'last_studied': new Date().toISOString()}]
          this.update_currentWordLearnt(word)
          newGold++;
          newSilver--;
        }
      }

      this.set_level_copper(this.level_copper + newBronze)
      this.set_level_silver(this.level_silver + newSilver)
      this.set_level_gold(this.level_gold + newGold)

    }

  },

  data() {
    return {
      sessionDuration: 60 * 1000,

      component: this.$session.get('component') || "vocabularyCardWord",
      endSessionValue: false,
      properties: {
        wordNumValue: this.$session.get('wordNum') || 1,
        testNumValue: this.$session.get('testNum') || 0,
        lastQuizzValue: [],
        voicesListValue: []
      },
      /*
      componentMessages: {
        "vocabularySessionStart": "Bienvenue !",
        "vocabularyCardWord": "Nouveau mot",
        "vocabularyCardTest": "Traduis !",
        "vocabularyEnding": "Ready !",
        "vocabularySynopsis": "• Synopsis •",
        "vocabularyToNetflix": "Bon visionnage !",
        "vocabularyUserReturn": "Ton avis nous intéresse !"
      },*/
      screenWidth: window.screen.width
    }
  }
}

</script>

<style scoped>

#vocabularyCardBody {
  position: relative;
  /*height: calc(100% - 2vw);*/
  flex-grow : 1;
  display: grid;
  grid-template-columns: 26% 1fr;
  grid-template-rows: 4vw 1fr 1vw;
  padding: 1vw;
  grid-gap: 1vw;
}

#whitebg2 {
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  grid-column: 2/3;
  grid-row: 1/3;
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;
  border-radius: 1vw;
  z-index: 3;
}

#loadingWords {
  grid-column: 2/3;
  grid-row: 1/4;
}

#component {
  grid-column: 1/2;
  grid-row: 1/4;
}

#componenttype {
  grid-column: 1/2;
  grid-row: 1/2;
  border-radius: 0 0 1.5vw 0;
  height: fit-content;
  width: fit-content;
  font-weight: bolder;
  text-shadow: 1px 1px #22222255;
  background-color: var(--text_color);

  padding: 0.25vw 1.5vw 0.25vw 1.5vw;
  justify-self: left;
  z-index: 3;
}
/*
#progress {
  position: absolute;
  flex-direction: column;
  top: 0.5vw;
  left: calc(50% - 1.5vw);
  height: 3vw;
  width: 3vw;
  border-radius: 3vw;
  font-weight: bold;
  z-index: 3;
}*/
#progress {
  grid-column: 2/3;
  grid-row: 3/4;
  overflow: hidden;
  width: 95%;
  justify-self: center;
  z-index: 3;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 0.25vw;
  /*color: var(--lightColor);*/
  align-items: center
}



#beingLearnt {
  grid-column: 1/2;
  grid-row: 2/4;
  max-height: 100%;
  height: 100%;

  flex-direction: column;
  align-content: center;
  /*overflow-y: auto;
  overflow-x: hidden;*/
}

.wordBeingLearnt {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: top;
  font-weight: bold;
  margin-bottom: 0.3vw;
  max-height: 1.4em;
  z-index: 4;
  overflow: hidden;
}

.vocabPoints{
  font-size: 0.6em;
  padding: 0.12vw 0.25vw 0.12vw 0.25vw;
  background-color: #02020266;
  border-radius: 2vw;
}

.quit {
  width: 2.5vw;
  height: 1vw;
  background: #f91e48;
}

.slidefade-item {
  transition: all 1s;
}

.slidefade-enter {
  opacity: 0;
  transform: translateX(2vw);
}

.slidefade-leave-active {
  position: absolute;
}

@media screen and (max-device-width: 767px) {
  #vocabularyCardBody {
    position: relative;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 10vw;
    padding: 0;
    grid-gap: 2vw;
  }
  #componenttype {
    border-radius: 0 0 5vw 0;
    padding: 1vw 5vw 1vw 5vw;
  }


  #component {
    grid-column: 1/2;
    grid-row: 1/3;

    height: 90%;
  }

  #whitebg2 {
    grid-template-rows: auto 1fr;
    grid-column: 1/2;
    grid-row: 1/3;
    border-radius: 0;
  }

  #loadingWords {
    grid-column: 1/3;
    grid-row: 1/2;
  }
  #progress {
    grid-column: 1/2;
    grid-row: 2/3;
    width: 80%;
  }
}
</style>
